/**
 * Agent Chat AI对话页面翻译
 */

import type { TranslationDict } from '../types';

export const agentChat: TranslationDict = {
  pageTitle: {
    en: 'Chat with AI',
    'zh-CN': 'AI对话',
    ja: 'AIチャット',
  },
  placeholder: {
    en: 'Message {name}...',
    'zh-CN': '和{name}聊聊...',
    ja: '{name}と話す...',
  },
  send: {
    en: 'Send',
    'zh-CN': '发送',
    ja: '送信',
  },
  typing: {
    en: '{name} is typing...',
    'zh-CN': '{name}正在输入...',
    ja: '{name}が入力中...',
  },
  startChat: {
    en: 'Start chatting with {name}',
    'zh-CN': '开始和{name}对话',
    ja: '{name}と会話を始める',
  },
  error: {
    send: {
      en: 'Failed to send message',
      'zh-CN': '发送失败',
      ja: '送信に失敗しました',
    },
  },
};
